var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("base-view", { staticClass: "gfu-blog" }, [
    _c(
      "main",
      {
        staticClass:
          "gfu-layout__main gfu-layout__main--extranarrow js-main-content",
      },
      [
        _vm.hasItems
          ? _c(
              "div",
              { staticClass: "col-12" },
              [
                _vm._l(_vm.pagedItems, function (post) {
                  return _c("blog-post-details-card", {
                    key: post.urlName,
                    staticClass: "mb-4",
                    attrs: { "blog-post": post, "is-preview": "" },
                  })
                }),
                _vm._v(" "),
                _vm.isMoreVisible
                  ? _c(
                      "div",
                      { staticClass: "_flex _jc-c _mt-3" },
                      [
                        _c(
                          "processing-button",
                          {
                            attrs: {
                              theme: "outline",
                              "is-processing": _vm.isProcessing,
                            },
                            on: { click: _vm.onMore },
                          },
                          [
                            _vm._v(
                              "\n                    " +
                                _vm._s(_vm.Resources.Common.LoadMoreButton) +
                                "\n                "
                            ),
                          ]
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.canLoadMoreRows
                  ? _c(
                      "load-more-trigger",
                      { on: { "load-more": _vm.onMore } },
                      [
                        _c(
                          "div",
                          { staticClass: "_flex _jc-c _mt-3" },
                          [
                            _c(
                              "processing-button",
                              { attrs: { "is-processing": true } },
                              [
                                _vm._v(
                                  "\n                        " +
                                    _vm._s(
                                      _vm.Resources.Common.LoadMoreButton
                                    ) +
                                    "\n                    "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                      ]
                    )
                  : _vm._e(),
              ],
              2
            )
          : _vm.isProcessing
          ? _c("skeleton-blog-post-list")
          : !_vm.isProcessing
          ? _c(
              "div",
              { staticClass: "gfu-blog__item" },
              [
                _c(
                  "base-heading",
                  { attrs: { variant: "decorative", tag: "h2" } },
                  [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.Resources.Blog.PageHeader) +
                        "\n            "
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "gfu-subheading gfu-subheading--main _pb-3" },
                  [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.Resources.Blog.EmptyStateListParagraph) +
                        "\n            "
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    staticClass: "gfu-link gfu-link--accent",
                    attrs: { href: _vm.mainPageLink },
                  },
                  [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.Resources.Blog.BackToMainPageLink) +
                        "\n            "
                    ),
                  ]
                ),
              ],
              1
            )
          : _vm._e(),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }